import clsx from 'clsx'
import { useStyles } from '../RevenueByProductChart.styles'
import { Divider } from '@mui/material'
import { getCloudImg } from '../../RevenueOverviewChart/RevenueOverviewChart'
import { DefaultRawDatum, PieTooltipProps } from '@nivo/pie'
import { PieDataInfo } from '../RevenueByProductChart'
import { numberFormat } from '@labrav/common'

export type PieCustomTooltipProps = {
  point: PieTooltipProps<DefaultRawDatum>
  otherProducts: PieDataInfo[]
  preFix?: string
  percentage?: number
}

export const PieCustomTooltip = ({
  point,
  otherProducts,
  preFix,
  percentage,
}: PieCustomTooltipProps) => {
  const { classes } = useStyles()
  const isOther = point?.datum?.data?.id === 'Other'
  const commonTooltip = (
    <div
      className={clsx(classes.tooltip, !isOther ? classes.tooltipPadding : '')}
      data-testid={'tooltip-wrapper'}
    >
      <div
        className={classes.percentage}
        style={{ background: point.datum.color }}
        data-testid={'tooltip-percentage'}
      >
        {percentage}%
      </div>
      <div data-testid={'tooltip-label'}>
        {point.datum.data?.id}: {preFix ? preFix : ''}{' '}
        {numberFormat(point.datum.data.value)}
      </div>
    </div>
  )
  if (isOther) {
    return (
      <div
        className={classes.tooltipWithList}
        data-testid={'tooltip-list-wrapper'}
      >
        {commonTooltip}
        <Divider className={classes.divider} />

        {otherProducts.map(item => {
          return (
            <div
              className={classes.tooltipProduct}
              data-testid={'tooltip-list-item'}
            >
              {item?.cloud && (
                <div className={classes.imgIcon}>
                  <img src={getCloudImg(item?.cloud)} height={'16px'} />
                </div>
              )}
              <span
                className={classes.productNameValue}
                data-testid={'tooltip-list-label-value'}
              >
                <span>{item?.label}: </span>
                <span>
                  {preFix ? 'USD' : ''} {numberFormat(item?.value)}
                </span>
              </span>
            </div>
          )
        })}
      </div>
    )
  }
  return commonTooltip
}
